<template>
  <a-form-field
    v-bind="formFieldAttrs"
    :max-length="maxLength"
    :value-length="valueLength"
    :validation-hints="validationHints"
  >

    <template slot-scope="slotProps">

      <!--
        Had to duplicate input element and conditionally
        switch between one with binded value and one without.
        Otherwise input/change events on other CFormInputs
        would cause the file-type input to re-render and
        seem to be empty, even if there is actually a file
        saved in the component.
      -->

      <input
        v-if="$attrs.type === 'file'"
        ref="input"
        :aria-describedby="slotProps.describedby"
        :aria-invalid="hasError ? 'true' : 'false'"
        :id="id"
        v-bind="$attrs"
        class="form-input"
        v-on="listeners"
      >

      <input
        v-else
        ref="input"
        :aria-describedby="slotProps.describedby"
        :aria-invalid="hasError ? 'true' : 'false'"
        :id="id"
        :value="value"
        v-bind="$attrs"
        class="form-input"
        v-on="listeners"
      >
    </template>

  </a-form-field>
</template>

<script>
import AFormField from '@/components/form/atoms/AFormField'
import BFormInput from '@/components/form/base/BFormInput'

export default {
  name: 'CFormInput',

  components: {
    AFormField
  },

  extends: BFormInput,

  props: {
    value: {
      type: [Number, String]
    },
    maxLength: {
      type: Number,
      default: 0
    },
    validationHints: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    valueLength () {
      if (this.value) {
        return this.value.length
      }

      return 0
    }
  }
}
</script>

<style>
.sublabel-field {
  width: 100%;
}
</style>
